import { render, staticRenderFns } from "./MatchMaking.vue?vue&type=template&id=a4c25db2&scoped=true&"
import script from "./MatchMaking.vue?vue&type=script&lang=js&"
export * from "./MatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./MatchMaking.vue?vue&type=style&index=0&id=a4c25db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c25db2",
  null
  
)

export default component.exports